<template>
  <div class="p-16">
    <div class="max-w-5xl mx-auto space-y-16">
      <div class="flex items-center justify-between">
        <h4 class="text-indigo-500 capitalize">Ad Plans</h4>
      </div>

      <BaseAdvancedList searchable :loading="loading" :entities="campaigns" :meta="meta">
        <template #default="listProps">
          <ListItem
            :account-id="accountId"
            :campaign="listProps.entity"
            @edit="setCurrent($event)"
          />
        </template>
      </BaseAdvancedList>
    </div>

    <portal v-if="campaign" to="app-dialog">
      <CampaignModal :campaign-id="campaign.id" @campaign-modal-close="setCurrent(null)" />
    </portal>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex';
import { middleware } from '@/routes/guards';
import ListItem from '@/components/AccountCampaigns/ListItem.vue';
import CampaignModal from '@/components/Campaigns/CampaignModal.vue';

export default {
  name: 'CampaignIndex',
  components: {
    ListItem,
    CampaignModal,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('ui/accountCampaigns', ['meta']),
    ...mapGetters('ui/accountCampaigns', ['campaign', 'campaigns']),
  },

  watch: {
    $route: 'fetchData',
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  beforeRouteEnter: middleware('account-permission:read campaigns'),

  methods: {
    ...mapActions('ui/accountCampaigns', {
      loadCampaigns: 'getCampaigns',
    }),
    ...mapMutations('ui/accountCampaigns', ['setCurrent', 'setIds', 'setMeta', 'setLinks']),

    async init() {
      this.fetchData();
    },

    async fetchData() {
      const { query } = this.$route;
      this.loading = true;
      try {
        await this.loadCampaigns({
          accountId: this.accountId,
          params: {
            ...query,
            include: [
              'channels',
              'channableData',
              'gaCampaigns.gaAds',
              'gaReportsAggregatedOnCampaignLevel',
              'contactRequestsCount',
              'channelsCount',
              'accounts.media',
              'media',
              'project.media',
            ].join(','),
          },
        });
      } catch (error) {
        //
      }
      this.loading = false;
    },
  },
};
</script>
